import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const faqs = [
  {
    q: 'Preciso ter conhecimento técnico para contratar palestra silenciosa?',
    a: 'Não. O fornecedor cuida de toda a parte técnica — montagem, operação, suporte e desmontagem. O guia explica exatamente o que você precisa saber para fazer as perguntas certas, mas a execução fica com a equipe especializada.',
  },
  {
    q: 'Funciona para eventos ao ar livre?',
    a: 'Sim, e é uma das aplicações mais impressionantes. O sinal de radiofrequência alcança até 100 metros em campo aberto. Para áreas maiores, antenas direcionais garantem cobertura total. Sem vento atrapalhando o som, sem dispersão de áudio.',
  },
  {
    q: 'Quanto custa em média?',
    a: 'O custo varia conforme o número de fones, canais e duração do evento. Mas a economia gerada — ao eliminar a necessidade de múltiplas salas, cabines de tradução e equipamentos de som convencionais — costuma ser de 40% a 60% em relação ao formato tradicional. O guia inclui uma seção completa sobre orçamento.',
  },
  {
    q: 'Os participantes mais velhos se adaptam aos fones?',
    a: 'Sim, é uma das surpresas mais legais. Os fones são leves, confortáveis e o ajuste de volume é intuitivo — basta girar um botão. Nossa equipe orienta cada pessoa individualmente na entrada. O feedback dos participantes 60+ é consistentemente positivo.',
  },
  {
    q: 'O guia substitui a necessidade de contratar um fornecedor?',
    a: 'O guia é um material educativo para você tomar decisões informadas. Ele cobre tudo que você precisa saber para planejar, comparar propostas e executar com excelência. A operação técnica continua sendo feita pelo fornecedor especializado — o guia te deixa no controle do processo.',
  },
  {
    q: 'Posso usar o guia para qualquer tipo de evento?',
    a: 'Sim. O guia cobre conferências corporativas, treinamentos, congressos científicos, eventos multilíngues, festivais, casamentos e muito mais. Cada formato tem suas particularidades e o capítulo 4 é dedicado exclusivamente às aplicações por tipo de evento.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section ref={ref} className="py-20 md:py-32 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
            Dúvidas Comuns
          </span>
          <h2
            className={`font-heading font-bold text-4xl md:text-6xl text-secondary transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            perguntas frequentes
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl border border-gray-100 overflow-hidden transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer group"
              >
                <h4 className="font-heading font-semibold text-sm md:text-base text-secondary group-hover:text-primary transition-colors pr-4">
                  {faq.q}
                </h4>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-45 bg-primary/10' : ''
                  }`}
                >
                  <i className={`ri-add-line text-sm ${openIndex === i ? 'text-primary' : 'text-gray-400'}`} />
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="font-body text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}